
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const IntroductionSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Introduction</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-gray-700">
        At SocialScoop, we respect your privacy and are committed to protecting your personal data. 
        This privacy policy explains how we collect, use, and safeguard your information when you use our service.
      </p>
    </CardContent>
  </Card>
);

export const InformationCollectionSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Information We Collect</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-gray-700">
        <h3 className="font-semibold">Personal Information</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>Email address when you join our waitlist</li>
          <li>Authentication information when you create an account</li>
          <li>Social media account data when you connect platforms</li>
        </ul>
        
        <h3 className="font-semibold mt-4">Usage Information</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>How you interact with our service</li>
          <li>Filtering preferences and rules you create</li>
          <li>Technical information about your device and browser</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);

export const DataUsageSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>How We Use Your Information</CardTitle>
    </CardHeader>
    <CardContent>
      <ul className="list-disc list-inside space-y-2 text-gray-700">
        <li>To provide and improve our content filtering service</li>
        <li>To communicate with you about updates and features</li>
        <li>To authenticate your account and ensure security</li>
        <li>To analyze usage patterns and improve our platform</li>
      </ul>
    </CardContent>
  </Card>
);

export const DataSharingSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Data Sharing</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-gray-700">
        We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, 
        except as described in this policy. We may share information with trusted service providers who assist us in 
        operating our platform, conducting our business, or serving our users.
      </p>
    </CardContent>
  </Card>
);

export const DataSecuritySection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Data Security</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-gray-700">
        We implement appropriate security measures to protect your personal information against unauthorized access, 
        alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
      </p>
    </CardContent>
  </Card>
);

export const UserRightsSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Your Rights</CardTitle>
    </CardHeader>
    <CardContent>
      <ul className="list-disc list-inside space-y-2 text-gray-700">
        <li>Access and update your personal information</li>
        <li>Request deletion of your data</li>
        <li>Opt out of marketing communications</li>
        <li>Export your data in a portable format</li>
      </ul>
    </CardContent>
  </Card>
);

export const ContactSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Contact Us</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-gray-700">
        If you have any questions about this Privacy Policy, please contact us at:{' '}
        <a href="mailto:privacy@socialscoop.ai" className="text-blue-600 hover:underline">
          privacy@socialscoop.ai
        </a>
      </p>
    </CardContent>
  </Card>
);
